module.exports = __webpack_public_path__ + "img/shop.6e236721.jpg";